module.exports = __webpack_public_path__ + "static/img/customer.8c6d30ce.png";